import { Steps as StepsA } from 'antd';

type P = {
  currentStep: number;
  numberOfSteps: number;
  onChange?: (step: number) => void;
};

const Steps = ({ currentStep, numberOfSteps, onChange }: P) => {
  return (
    <StepsA current={currentStep} onChange={onChange} className="steps">
      {[...Array.from({ length: numberOfSteps }).keys()].map((key) => (
        <StepsA.Step key={`step-${key}`} />
      ))}
    </StepsA>
  );
};

export default Steps;
